import { APIService } from "./index";

export const getProjects = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllProjects(pageNo,pageSize);
    }
    else{
        try {
            res = await searchProjects(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data && res.data.document){
    return res.data.document;
    }else{
    return { records:[], totalCount:0 }
    }
    
}

export const filterProjectsWithColumns = async (filtercondition) => {
  let res;

  try {
    res = await filterProjects(filtercondition);
 
  } catch (err) {
    return { records: [], totalCount: 0 };
  }

  if (res && res.data && res.data.document) {
  
    return res.data.document;
  } else {
    return { records: [], totalCount: 0 };
  }
};


export const getOneRelationalProjects = (project_id) => {
return APIService.api().get(`/projects/Relational/${project_id}`)
}
export const getAllRelationalProjects = (pageno,pagesize) => {
return APIService.api().get(`/projects/Relational?page=${pageno}&itemsPerPage=${pagesize}`)
}
export const getAllProjects = (pageno,pagesize) => {
return APIService.api().get(`/projects?page=${pageno}&itemsPerPage=${pagesize}`)
}
export const getOneProjects = (id) => {
return APIService.api().get(`/projects/${id}`)
}
export const searchProjects = (key,pageno,pagesize) => {
return APIService.api().get(`/projects/search?searchKey=${key}&page=${pageno}&itemsPerPage=${pagesize}`)
}
export const addProjects = (data) => {
return APIService.api().post(`/projects/`,data)
}
export const updateProjects = (id1,data) => {
return APIService.api().put(`/projects/${id1}/`,data)
}
export const deleteProjects = (project_id) => {
return APIService.api().delete(`/projects/${project_id}/`)
}
export const filterProjects = (data) => {
return APIService.api().post(`/projects/filter`,data)
}
